import Vue from 'vue';
Vue.filter('_moment', function (val, format = "YYYY/MM/DD HH:mm", optionFormat = 'YYYY/MM/DD HH:mm') {
    const str = Vue.moment(val, optionFormat).format(format)
    return str;
});